"use client"

import { Dialog, DialogActions, DialogBody, DialogDescription, DialogTitle } from "@ui/dialog"
import { useDismissMemory } from "../../../../../components/layout/TopBanner"
import { Button } from "@ui/button"
import { BlackText } from "@ui/text"
import Link from "next/link"

export function Disclaimer() {
    const { dismiss, isDismissed } = useDismissMemory({ key: "virtual-ray-disclaimer-v1" })

    return (
        <Dialog open={!isDismissed} onClose={dismiss} size="3xl">
            <DialogTitle>Virtual Ray</DialogTitle>
            <DialogDescription>Disclaimer</DialogDescription>
            <DialogBody className="prose max-w-max">
                <BlackText>
                    This product is currently in test mode. Virtual Ray accesses Ray’s posts, articles and courses from
                    the last 20 years and tries to give the answer to your question that Ray would give.
                </BlackText>
                <BlackText>
                    This is quite different from say ChatGPT or Gemini, which would give you the most probable answer
                    that the population would give you. If Virtual Ray thinks Ray would not know the answer, it says so,
                    rather than drawing on an LLM to guess or hallucinate an answer.
                </BlackText>
                <BlackText>
                    This version is free, but it will only be live for a few days, as an MVP, to enable us to see what
                    works and what needs to be changed.
                </BlackText>
                <BlackText>
                    If Virtual Ray does not know the answer you will have the option of sending Ray your email address.
                    Ray will try to answer it himself. Your email address will not be added to a database as a
                    consequence of replying.
                </BlackText>
                <p className="hidden lg:block">
                    <Link href="/policies/terms">Terms and Conditions</Link>
                </p>
                <p className="hidden lg:block">
                    <Link href="/policies/privacy">Privacy Policy</Link>
                </p>
            </DialogBody>
            <DialogActions>
                <Button onClick={() => dismiss()}>Dismiss</Button>
            </DialogActions>
        </Dialog>
    )
}
